<template>
  <footer class="page-footer" role="contentinfo">
    <div class="d-flex align-items-center flex-1">
      <span class="hidden-md-down fw-700">
        {{ version }} {{ buildDate | moment('YYYY') }} &copy; {{ appTitle }} by&nbsp;
        <a href="https://witkac.pl" class="fw-500" target="_blank">Witkac sp. z o.o.</a>
      </span>
    </div>
  </footer>
</template>
<script>
import { mapState } from 'vuex';

// @vuese
// Stopka
// @group AppLayout
export default {
  name: 'Footer',
  computed: {
    copyYear() {
      return new Date().getFullYear();
    },
    ...mapState({
      version: state => state.system.packageVersion,
      appTitle: state => state.system.appTitle,
      buildDate: state => new Date(state.system.buildDate)
    })
  }
};
</script>
